import { Expose } from 'class-transformer';

export default class InvitationFormError {
  practice_id: string[] = []
  position: string[] = []
  to: string[] = []
  @Expose({ name: '_schema' }) schema: string[] = []
}